<div class="container">
  <mat-card class="hero-card" appearance="outlined">
    <mat-card-header>
      <mat-card-title-group>
        <mat-card-title>
          <h1>Hey, I'm Oleh Rumyk</h1>
        </mat-card-title>
        <mat-card-subtitle class="role">DevOps Engineer</mat-card-subtitle>
        <mat-card-subtitle class="experience">{{ experience }}</mat-card-subtitle>
        <img mat-card-xl-image src="/images/main-foto.png" alt="Oleh Rumyk">
      </mat-card-title-group>
    </mat-card-header>
    <mat-card-content>
      <p class="summary">{{ summary }}</p>
      <div class="specialties">
        @for (s of specialties; track s) {
          <span class="specialty-tag">{{ s }}</span>
        }
      </div>
      <div class="actions">
        <a mat-flat-button [href]="platform" target="_blank" rel="noopener" class="platform-btn">
          <mat-icon>open_in_new</mat-icon> Visit Platform
        </a>
        <a mat-stroked-button [href]="linkedIn" target="_blank" rel="noopener">LinkedIn</a>
      </div>
    </mat-card-content>
  </mat-card>
</div>
